import { defineComponent, ref, watch } from "vue";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
import * as pdfjsLib from "pdfjs-dist/webpack.mjs";
export default defineComponent({
    name: "PdfViewer",
    props: {
        pdfBlob: {
            type: Blob,
            required: true
        },
        containerStyle: {
            type: String,
            default: ""
        },
        canvasStyle: {
            type: String,
            default: ""
        },
        firstOnly: {
            type: Boolean,
            default: false
        }
    },
    setup(props) {
        /**1ページごとのpdf情報 */
        const canvasRefs = ref([]);
        /**ページ数 */
        const totalPages = ref(0);
        // PDF.js ワーカーの設定
        pdfjsLib.GlobalWorkerOptions.workerSrc = new URL("pdfjs-dist/legacy/build/pdf.worker.min.mjs", import.meta.url).toString();
        const isLoading = ref(false);
        const setCanvasRef = (index) => (el) => {
            canvasRefs.value[index] = el;
        };
        const renderAllPages = async (pdf) => {
            totalPages.value = props.firstOnly ? 1 : pdf.numPages;
            /* eslint-disable no-await-in-loop */
            for (let i = 1; i <= totalPages.value; i++) {
                const page = await pdf.getPage(i);
                const scale = 1.5;
                const viewport = page.getViewport({ scale });
                const canvas = canvasRefs.value[i - 1];
                if (!canvas) {
                    continue;
                }
                const context = canvas.getContext("2d", { willReadFrequently: true });
                canvas.width = viewport.width;
                canvas.height = viewport.height;
                await page.render({
                    canvasContext: context,
                    viewport
                }).promise;
            }
            /* eslint-enable no-await-in-loop */
        };
        // props.pdfBlob が変わったときに描画
        watch(() => props.pdfBlob, async (newBlob) => {
            if (!newBlob) {
                return;
            }
            canvasRefs.value = [];
            try {
                isLoading.value = true;
                const buffer = await newBlob.arrayBuffer();
                const typedArray = new Uint8Array(buffer);
                const wasmUrl = new URL("pdfjs-wasm/", document.baseURI).href;
                const cMapUrl = new URL("cmaps/", document.baseURI).href;
                const pdf = await pdfjsLib.getDocument({
                    data: typedArray,
                    cMapUrl,
                    cMapPacked: true,
                    wasmUrl,
                    useWasm: true,
                    useWorkerFetch: true
                }).promise;
                await renderAllPages(pdf);
            }
            catch (err) {
                console.error("PDF全ページ描画エラー:", err);
            }
            finally {
                isLoading.value = false;
            }
        }, { immediate: true });
        return {
            totalPages,
            setCanvasRef,
            props,
            isLoading
        };
    }
});
